<!-- Skeleton Loading State -->
<div class="analysis-container" *ngIf="isProcessing && !data">
  <!-- Eyebrow -->
  <div class="an-eyebrow">
    <ion-icon name="analytics-outline" aria-hidden="true"></ion-icon>
    <span>{{ 'NOVA_CALL_ANALYSIS' | translate }}</span>
  </div>

  <div class="analysis-scroll">
    <div class="analysis-header" aria-busy="true" [attr.aria-label]="'NOVA_LOADING_ANALYSIS' | translate">
      <div class="skeleton-ring" aria-hidden="true">
        <div class="skeleton-ring-inner"></div>
      </div>
      <div class="header-text">
        <ion-skeleton-text [animated]="true" class="skeleton-heading"></ion-skeleton-text>
      </div>
    </div>

    <div class="section skeleton-card" aria-busy="true" [attr.aria-label]="'NOVA_LOADING_KEY_MESSAGES' | translate">
      <ion-skeleton-text [animated]="true" class="skeleton-line w-60"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" class="skeleton-bar"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" class="skeleton-line w-80"></ion-skeleton-text>
    </div>

    <div class="section">
      <div class="tag-pills">
        <ion-skeleton-text [animated]="true" class="skeleton-pill" *ngFor="let i of [1,2]"></ion-skeleton-text>
      </div>
    </div>
  </div>
</div>

<!-- Analysis View -->
<div class="analysis-container" *ngIf="data">
  <!-- Eyebrow -->
  <div class="an-eyebrow">
    <ion-icon name="analytics-outline" aria-hidden="true"></ion-icon>
    <span>{{ 'NOVA_CALL_ANALYSIS' | translate }}</span>
  </div>

  <div class="analysis-scroll">
    <!-- Hero card: sentiment ring + title -->
    <div
      class="analysis-header"
      *ngIf="data.sentiment_analysis; else noSentimentHeader">
      <div
        class="sentiment-ring"
        [style.background]="getSentimentRingStyle()"
        [attr.aria-label]="'NOVA_SENTIMENT_CONFIDENCE_LABEL' | translate: { sentiment: data.sentiment_analysis.overall_sentiment, percent: ((data.sentiment_analysis.confidence ?? 0) * 100 | number:'1.0-0') }"
        role="img">
        <div class="sentiment-inner">
          <span class="sentiment-pct">{{ (data.sentiment_analysis.confidence ?? 0) * 100 | number:'1.0-0' }}%</span>
          <span class="sentiment-label">{{ data.sentiment_analysis.overall_sentiment }}</span>
        </div>
      </div>
      <div class="header-text">
        <h2>{{ data.summary_title }}</h2>
      </div>
    </div>
    <ng-template #noSentimentHeader>
      <div class="analysis-header no-ring">
        <div class="header-text">
          <h2>{{ data.summary_title }}</h2>
        </div>
      </div>
    </ng-template>

    <!-- Key Messages -->
    <div class="section" *ngIf="data.key_messages?.length">
      <h3 class="section-title">
        <ion-icon name="chatbubbles-outline" aria-hidden="true"></ion-icon> {{ 'NOVA_KEY_MESSAGES' | translate }}
      </h3>
      <div
        class="key-message-item"
        *ngFor="let km of data.key_messages"
        (click)="toggleKeyMessage(km)"
        (keyup.enter)="toggleKeyMessage(km)"
        role="button"
        tabindex="0"
        [attr.aria-pressed]="!!km.accepted"
        [attr.aria-label]="'NOVA_ITEM_CONFIDENCE_LABEL' | translate: { name: km.key_message, percent: (getConfidencePct(km.confidence) | number:'1.0-0') }">
        <div class="km-header">
          <ion-checkbox [checked]="km.accepted" mode="ios" color="success" aria-hidden="true"></ion-checkbox>
          <span class="km-name">{{ km.key_message }}</span>
          <span class="km-confidence">{{ getConfidencePct(km.confidence) | number:'1.0-0' }}%</span>
        </div>
        <div class="km-bar-track" role="presentation">
          <div
            class="km-bar-fill"
            [style.width.%]="getConfidencePct(km.confidence)"
            [attr.aria-hidden]="true"></div>
        </div>
        <p class="km-excerpt">"{{ km.excerpt }}"</p>
      </div>
    </div>

    <!-- Therapeutic Areas -->
    <div class="section" *ngIf="data.therapeutic_areas?.length">
      <h3 class="section-title">
        <ion-icon name="medkit-outline" aria-hidden="true"></ion-icon> {{ 'THERAPEUTIC_AREAS' | translate }}
      </h3>
      <div class="tag-pills">
        <span
          class="pill"
          *ngFor="let ta of data.therapeutic_areas"
          [attr.aria-label]="'NOVA_ITEM_CONFIDENCE_LABEL' | translate: { name: ta.therapeutic_area, percent: (getConfidencePct(ta.confidence) | number:'1.0-0') }">
          {{ ta.therapeutic_area }}
          <span class="pill-confidence" aria-hidden="true">{{ getConfidencePct(ta.confidence) | number:'1.0-0' }}%</span>
        </span>
      </div>
    </div>

    <!-- Follow-Up Items -->
    <div class="section" *ngIf="data.follow_up_items?.length">
      <h3 class="section-title">
        <ion-icon name="list-outline" aria-hidden="true"></ion-icon> {{ 'NOVA_FOLLOW_UP_ITEMS' | translate }}
      </h3>
      <div class="follow-up-item" *ngFor="let item of data.follow_up_items">
        <span [class]="getPriorityClass(item.priority)">{{ item.priority }}</span>
        <span class="follow-up-text">{{ item.item }}</span>
      </div>
    </div>
  </div>

  <!-- Footer: Apply button -->
  <div class="apply-footer">
    <div class="footer-buttons">
      <button
        class="apply-btn"
        (click)="onApply()"
        [disabled]="!hasAcceptedMessages"
        [attr.aria-disabled]="!hasAcceptedMessages">
        {{ 'NOVA_APPLY_SELECTED' | translate }}
      </button>
    </div>
  </div>
</div>
